import WebsiteRedirectsPage from '@/components/websites/WebsiteRedirectsPage'
import { createFileRoute } from '@tanstack/react-router'
import { loadWebsiteRedirectsRoute } from './-loader'

export const websiteRedirectsLoader = (args) => loadWebsiteRedirectsRoute(args)

export const Route = createFileRoute('/_authenticated/$orgId/website/url-redirects/')({
  component: WebsiteRedirectsPage,
  loader: websiteRedirectsLoader,
})
